import * as React from "react";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { Typography } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Link } from "react-router-dom";

export default function IconMenu(props) {
  return (
    <Paper
      sx={{
        width: 200,
        maxWidth: "100%",
        height: "fit-content",
        backgroundColor: "primary.light",
      }}
      elevation="3"
    >
      <MenuList>
        <MenuItem
          divider="true"
          sx={{
            backgroundColor: "primary.light",
            "&:hover": {
              bgcolor: "primary.light",
            },
          }}
        >
          <ListItemIcon>{props.menuHeader.icon}</ListItemIcon>
          <Typography sx={{ color: "white" }}>
            {props.menuHeader.name}
          </Typography>
        </MenuItem>
        {props.menu.map((item) => (
          <Link
            style={{
              textDecoration: "none",
            }}
            to={item.link}
            state={item.state}
          >
            <MenuItem
              divider="true"
              sx={{
                textDecoration: "none",
                color: "white",
                "&:hover": {
                  bgcolor: "grey.400",
                },
              }}
            >
              <ListItemText>{item.name}</ListItemText>
            </MenuItem>
          </Link>
        ))}
      </MenuList>
    </Paper>
  );
}
